import React, { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { BASE_CRM_URL } from "../../../components/config/config";
import { useParams } from "react-router-dom";
import { Spin } from "antd";

const ProjectActivityLog = () => {
  const { id } = useParams();
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);
  const getProjectActivity = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_CRM_URL}project/GetProjectActivity?Projectid=${id}`,
      );
      if (response?.data?.Status) {
        setActivities(response.data.ResultData || []);
      } else {
        setActivities([]);
      }
    } catch (error) {
      console.error("Error fetching project activity:", error);
      setActivities([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getProjectActivity();
  }, [id]);
  const getInitials = (name = "") => {
    return name
      .trim()
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((word) => word.charAt(0).toUpperCase())
      .join("");
  };
  const avatarColors = [
    "primary",
    "success",
    "info",
    "warning",
    "danger",
    "secondary",
  ];
  return (
    <div className="card border-0">
      {/* Header */}
      <div className="card-header bg-white border-bottom">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h5 className="mb-1 fw-semibold">
              <i className="ti ti-activity me-2 text-primary" /> Activity Log
            </h5>
          </div>
          <span className="badge bg-light text-dark border rounded-pill px-3 py-2">
            {activities.length} Activities
          </span>
        </div>
      </div>
      {/* Body */}
      <div className="card-body px-4 py-4">
        {loading ? (
          <div className="text-center py-5">
            <Spin size="large" />
            <p className="text-muted mt-3 mb-0">Loading activities...</p>
          </div>
        ) : activities.length === 0 ? (
          <div className="text-center py-5">
            <div className="mb-3">
              <span
                className="d-inline-flex align-items-center justify-content-center bg-light rounded-circle"
                style={{ width: "64px", height: "64px" }}
              >
                <i className="ti ti-activity fs-2 text-muted" />
              </span>
            </div>
            <h6 className="fw-semibold"> No activities found </h6>
            <p className="text-muted small mb-0">
              Project activities will appear here.
            </p>
          </div>
        ) : (
          <div>
            {activities.map((activity, index) => {
              const staffName =
                activity.StaffName || activity.fullname || "Unknown User";
              const color = avatarColors[index % avatarColors.length];
              return (
                <div
                  key={activity.id}
                  className="d-flex position-relative mb-4"
                >
                  <div
                    className="d-flex flex-column align-items-center me-3 position-relative"
                    style={{ width: "45px", flexShrink: 0 }}
                  >
                    {/* Avatar */}
                    <div
                      className={`bg-${color} text-white rounded-circle d-flex align-items-center justify-content-center fw-semibold flex-shrink-0`}
                      style={{
                        width: "42px",
                        height: "42px",
                        minWidth: "42px",
                        minHeight: "42px",
                        fontSize: "13px",
                        zIndex: 2,
                      }}
                    >
                      {getInitials(staffName)}
                    </div>

                    {/* Timeline line */}
                    {index !== activities.length - 1 && (
                      <div
                        className="position-absolute border-start"
                        style={{
                          top: "42px",
                          bottom: "-24px",
                          left: "50%",
                          transform: "translateX(-50%)",
                        }}
                      />
                    )}
                  </div>
                  {/* Activity */}
                  <div className="flex-grow-1">
                    <div className="card border shadow-none mb-0">
                      <div className="card-body p-3">
                        {/* Top section */}
                        <div className="d-flex justify-content-between align-items-start">
                          <div className="d-flex align-items-center flex-wrap gap-2">
                            <h6 className="mb-0 fw-semibold">{staffName}</h6>
                            <span className="badge bg-primary-subtle text-primary rounded-pill px-2 py-1">
                              <i className="ti ti-bolt me-1" />
                              {activity.description_key}
                            </span>
                          </div>
                          <div className="text-end">
                            <div className="text-muted small">
                              {dayjs(activity.dateadded).format("DD MMM YYYY")}
                            </div>
                            <div className="text-muted small">
                              {dayjs(activity.dateadded).format("hh:mm A")}
                            </div>
                          </div>
                        </div>
                        {/* Action */}

                        {/* Bottom information */}
                        <div className="d-flex flex-wrap align-items-center gap-3 ">
                          {/* Project */}
                          {activity.ProjectName && (
                            <div className="d-flex align-items-center">
                              <i className="ti ti-briefcase text-primary me-2" />
                              <span className="text-muted small">
                                {activity.ProjectName}
                              </span>
                            </div>
                          )}
                          {/* Visibility */}
                          {/* <div className="ms-auto">
                            {Number(activity.visible_to_customer) === 1 ? (
                              <span className="badge bg-success-subtle text-success rounded-pill px-3 py-2">
                                <i className="ti ti-eye me-1" /> Visible to
                                customer
                              </span>
                            ) : (
                              <span className="badge bg-secondary-subtle text-secondary rounded-pill px-3 py-2">
                                <i className="ti ti-eye-off me-1" />
                                Internal
                              </span>
                            )}
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
export default ProjectActivityLog;
